import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaCpfState } from './types';

export const INITIAL_STATE: ConsultaCpfState = {
	data: null,
	status: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaCpfState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CONSULTA_CPF_REQUEST: {
				break;
			}
			case Types.CONSULTA_CONSULTA_CPF_SUCCESS: {
				draft.data = action.payload;
				draft.status = 200;
				break;
			}

			case Types.CONSULTA_CONSULTA_CPF_FAILURE: {
				draft.data = INITIAL_STATE.data;
				draft.status = 400;
				break;
			}

			case Types.CONSULTA_CONSULTA_CPF_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
		return draft;
	});
}
